import {
  Box,
  Avatar,
  Badge,
  Text,
  Flex,
  Image,
  useColorModeValue,
  Select,
  useDisclosure,
  Divider,
} from "@chakra-ui/react";

import DepartmentFrame from "../../../../assets/images/DepartmentFrame.svg"
import BranchFrame from "../../../../assets/images/BranchFrame.svg";
import EmailFrame from "../../../../assets/images/EmailFrame.svg";
import PhoneFrame from "../../../../assets/images/PhoneFrame.svg";
import GenderFrame from "../../../../assets/images/GenderFrame.svg";
import CalenderFrame from "../../../../assets/images/CalenderFrame.svg";
import PayrollFrame from "../../../../assets/images/PayrollFrame.svg";
import ShiftFrame from "../../../../assets/images/ShiftFrame.svg";
import BackgroundProfile from "../../../../assets/images/ProfileBackground.jpg";
import ProfilePicture from "../../../../assets/images/ProfilePicture.jpg"
import CopyIcon from "../../../../assets/images/CopyIcon.svg"
import MyDiv from "./salaryHistoryCard.style";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { useEffect, useState } from "react";
import { AlertCard, CustomToast } from "../../../../components";
import Arrow from "../../../../assets/images/ArrowHistory.svg";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, } from '@chakra-ui/react'
import * as routesNames from '../../../../constants/routes'
import { useNavigate } from "react-router-dom";
import { useFetch } from "../../../../hooks/useFetch";

export interface StatusDD {
  id: number;
  employeeStatus: string;
}

const SalaryHistoryCard = ({ employeeId }: { employeeId: number }) => {
  const [statusDD, setStatusDD] = useState<StatusDD[]>([])
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [empData, setEmpData] = useState<any>({});
  const [pendingStatus, setPendingStatus] = useState<string>("");
  const handleStatusChange = (newStatus: string) => {
    setPendingStatus(newStatus);
    onOpen();
  };
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);

  async function profileDetail() {
    const response = await fetchApi('Hrlense_Employee/profileCard', "GET", null, `employeeId=${employeeId}`, "");
    if (response) {
      console.log("salary history:", response);
      setEmpData(response);
    }
  }

  const EmployeeStatusDD = async () => {
    try {
      const response = await fetchApi("DropDown/EmplyeeStatus", "GET", null, "", "");

      if (response?.length > 0) {
        let modifiedStatusDD = response.filter((item: any) =>
          ["Active", "Terminated", "Release", "Abscond"].includes(item.employeeStatus)
        );
        setStatusDD(modifiedStatusDD);
      } else {
        addToast({ message: "Empty employee status dropdown.", status: "error" });
      }
    } catch (error) {
      console.error("Failed to load employee status", error);
    }
  };
  const handleConfirmStatusChange = async () => {
    if (pendingStatus && empData) {
      try {
        const payload = {
          employeeId: empData.id,
          employeeStatusId: Number(pendingStatus),
        };
        const response = await fetchApi(`Hrlense_Employee/toggleEmpStatus/${empData.id}`, "PUT", payload, "", "Status updated successfully.");

        if (response) {
          // const updatedStatusName = statusDD.find((s) => s.id.toString() === pendingStatus)?.employeeStatus;
          // if (updatedStatusName) {
          //   setEmpData((prev: any) => prev ? { ...prev, status: updatedStatusName } : prev);
          // }
          profileDetail();
        }
      } catch (error) {
        addToast({ message: "An error occurred while updating status.", status: "error" });
      }
    }
    onClose();
  };
  useEffect(() => { EmployeeStatusDD(); profileDetail(); }, []);

  const navigate = useNavigate();
  const handleClick = () => {
    navigate(routesNames.EMPLOYEEDETAIL, { state: { employeeId: empData.id } })
  }
  const infoItems = [
    { icon: DepartmentFrame, label: "Department", value: empData.department },
    { icon: BranchFrame, label: "Branch", value: empData.branch },
    { icon: EmailFrame, label: "Email", value: empData.email },
    { icon: PhoneFrame, label: "Phone", value: empData.phone },
    { icon: GenderFrame, label: "Gender", value: empData.gender },
    { icon: CalenderFrame, label: "Age / DOB", value: `${empData.age}, (${empData.dob})`, },
    { icon: PayrollFrame, label: "Payroll Company", value: empData.payrollCompany, },
    { icon: PayrollFrame, label: "Company", value: empData.usCompany, },
    { icon: ShiftFrame, label: "Shift", value: empData.shift },
  ];

  return (
    <MyDiv>
      <Box className="profile-container">
        <Box className="fixed-header">
          <Flex className="page_heading flex_header">
            <Breadcrumb spacing='5px' className="font_poppins text_md text_medium" separator=">>">
              <BreadcrumbItem>
                <BreadcrumbLink className="font_poppins text_md text_medium" href={routesNames.PAYROLL} color="gray.500">Payroll</BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbItem isCurrentPage>
                <BreadcrumbLink className="font_poppins text_md text_medium" href='#'>Employee Salary History</BreadcrumbLink>
              </BreadcrumbItem>
            </Breadcrumb>
          </Flex>
        </Box>
        <Box className="scrollable-content">
          <Box className="main">
            <Box position="relative" h="140px" >
              <Image src={BackgroundProfile} alt="Cover" w="100%" h="100%" objectFit="cover" />
            </Box>
            <Flex align="center" gap={4} px={5} mt={-10}>
              <Avatar src={empData.avatarUrl} name={empData.name} size="xl" />
              <Box w="100%" mt={12} >
                <Flex justifyContent="space-between" alignItems="center" width="100%">
                  <Text className="font-poppins text_xl text_medium font_dark">
                    {empData.name}
                  </Text>
                  <Select
                    value={
                      statusDD.find((s) => s.employeeStatus === empData?.status)?.id.toString() ?? ""
                    }
                    onChange={(e) => handleStatusChange(e.target.value)}
                    className="font-poppins text_medium text_xsm"
                    width="78px"
                    height="22px"
                    icon={<ChevronDownIcon ml={2} />}
                    borderRadius="4px"
                    color={empData?.status === "Active" ? "#38A169" : "#E53E3E"}
                    bg={empData?.status === "Active" ? "#F0FFF4" : "#FFF5F5"}
                    sx={{ textAlign: "left", paddingLeft: "4px" }}
                  >
                    {statusDD.map((status) => (
                      <option key={status.id} value={status.id}>{status.employeeStatus}</option>
                    ))}
                  </Select>
                </Flex>

                <Flex gap={3} mt={2} alignItems="center" flexWrap="wrap">
                  <Badge className="Badge font-poppins text_medium" fontSize="8px" color="rgba(0, 0, 0, 0.5)" >
                    {empData.empCode}
                    <Image src={CopyIcon} alt="Copy" boxSize="11px" cursor="pointer" />
                  </Badge>
                  <Badge className="designation font-poppins text_sm text_medium" color="rgba(0, 122, 255, 1)">
                    {empData.designation}
                  </Badge>
                </Flex>
              </Box>
            </Flex>
            <Divider orientation='horizontal' mt={6} />
            <Box px={5} mt={6} pb={5}>
              <Text className="font-poppins text_sm text_medium" color="rgba(0, 0, 0, 1)" mb={3} >More Information</Text>
              <Box display="grid" rowGap={4}>
                {infoItems.map((item, idx) => (
                  <Flex key={idx} align="center" gap={3}>
                    <Image src={item.icon} boxSize="24px" alt={item.label} />
                    <Box>
                      <Text className="font-poppins text_medium" fontSize="9px" color="rgba(0, 0, 0, 0.5)">{item.label}</Text>
                      <Text className="font-poppins text_sm text_medium" color="rgba(0, 0, 0, 1)">{item.value}</Text>
                    </Box>
                  </Flex>
                ))}
                <Box mt={2} className="history_btn">
                  <Flex justifyContent="space-between" alignItems="center" cursor="pointer" onClick={handleClick}>
                    <Text className="font-poppins font_dark text_medium text_sm">View Employee Profile</Text>
                    <Image src={Arrow} alt="History" />
                  </Flex>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <AlertCard isOpen={isOpen} onClose={onClose} onConfirm={handleConfirmStatusChange} />
    </MyDiv>
  );
};

export default SalaryHistoryCard;
